import React, { useRef } from "react";
import { IFlowInputDataEditorState } from "../FlowInputManagement/FlowInputDataEditor";
import { FlowInputManagementController } from "../FlowInputManagement";
import { IBannerContext } from "@plex/react-components";

const UNASSIGNED: any | null = {};

export const ViewControllerContext = React.createContext<IViewController | any>(undefined);

export interface IViewController {
  flowInputController: FlowInputManagementController;
  flowInputDataEditorState: IFlowInputDataEditorState;
  setFlowInputDataEditorState: React.Dispatch<React.SetStateAction<IFlowInputDataEditorState>>;
  bannerContext: IBannerContext;
}

export const useViewController = (): IViewController | any => {
  return React.useContext(ViewControllerContext);
};

export const useSingleton = (factory: any) => {
  const sharedDataRef = useRef(UNASSIGNED);

  if (sharedDataRef.current == UNASSIGNED) {
    sharedDataRef.current = factory();
  }

  return sharedDataRef.current;
};
